import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Text } from 'pcln-design-system'

import ChildAgeSelect from './ChildAgeSelect'
import ControlIcon from './ControlIcon'

class Control extends React.Component {
  static contextTypes = {
    constants: PropTypes.shape({
      TRAVELER_TYPES: PropTypes.object.isRequired,
      TRAVELER_SUBTEXTS: PropTypes.object.isRequired,
      TRAVELER_LABELS: PropTypes.object.isRequired
    }).isRequired
  }

  static defaultProps = {
    travelerCount: 0,
    childIndex: 0,
    childAge: 0
  }

  static propTypes = {
    updateTravelerCount: PropTypes.func.isRequired,
    toggleIsControlPanelOpenState: PropTypes.func.isRequired,
    disabledIcons: PropTypes.object.isRequired,
    travelerCount: PropTypes.number,
    childIndex: PropTypes.number,
    childAge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isUsingControlLabel: PropTypes.bool,
    travelerType: PropTypes.string,
    updateChildAge: PropTypes.func
  }

  state = {
    value: 0
  }

  handleClick = e => {
    e.preventDefault()
    const isForceOpen = true
    this.props.toggleIsControlPanelOpenState(isForceOpen)
  }

  render () {
    const {
      TRAVELER_TYPES,
      TRAVELER_SUBTEXTS,
      TRAVELER_LABELS
    } = this.context.constants

    const {
      isUsingControlLabel,
      travelerType,
      travelerCount,
      childIndex,
      childAge,
      updateTravelerCount,
      updateChildAge,
      disabledIcons
    } = this.props

    const travelerLabel = TRAVELER_LABELS[travelerType]
    const subtext = TRAVELER_SUBTEXTS[travelerType]
    const isRoomCount = travelerType === TRAVELER_TYPES.ROOMS

    const evalRoomCount = () =>
      isRoomCount ? travelerCount === 1 : travelerCount === 0

    const isDecrementInvalid =
      disabledIcons.has(`${travelerType}_MINUS`) || evalRoomCount()

    const isIncrementInvalid = disabledIcons.has(`${travelerType}_PLUS`)

    const isChildAgeType = travelerType === TRAVELER_TYPES.CHILD_AGE

    return !isChildAgeType ? (
      <Flex
        px={3}
        justifyContent='space-between'
        alignItems='center'
        style={{ height: 52 }}
      >
        <Text.span fontSize={2}>
          {travelerLabel}
          {isUsingControlLabel && (
            <Text.span ml={1} fontSize={1} color='text.light'>
              {subtext}
            </Text.span>
          )}
        </Text.span>
        <Flex onClick={this.handleClick}>
          <ControlIcon
            iconName='radioMinus'
            travelerType={travelerType}
            updateTravelerCount={updateTravelerCount}
            isDisabled={isDecrementInvalid}
            isIncrement={false}
          />
          <Text
            id={`${travelerType}-number`}
            aria-live='polite'
            aria-atomic='true'
            fontSize={2}
            px={2}
            textAlign='center'
            style={{ width: '1.6em' }}
          >
            {travelerCount}
          </Text>
          <ControlIcon
            iconName='radioPlus'
            travelerType={travelerType}
            updateTravelerCount={updateTravelerCount}
            isDisabled={isIncrementInvalid}
            isIncrement
          />
        </Flex>
      </Flex>
    ) : (
      <ChildAgeSelect
        childIndex={childIndex}
        childAge={childAge}
        updateChildAge={updateChildAge}
      />
    )
  }
}

Control.displayName = 'Control'

export default Control
